export class BuyBonusButtonEvents {
    public static readonly BUY_BONUS_BUTTON_CLICKED: symbol = Symbol('BUY_BONUS_BUTTON_CLICKED');
}
